import React, { useEffect, useState } from "react";
import GetNewsService from "../../api/News/GetNews/getNewsService";
import axios from "axios";

const DeleteNewsPage = () => {
  const [newsList, setNewsList] = useState<{ _id: string; title: string }[]>([]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  useEffect(() => {
    GetNewsService()
      .then((data) => setNewsList(data))
      .catch((err) => console.error("Failed to fetch news:", err));
  }, []);

  const handleSelect = (id: string) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleBulkDelete = async () => {
    if (selectedIds.length === 0) {
      alert("No news selected!");
      return;
    }

    try {
      await axios.post("/api/news/delete-multiple", { ids: selectedIds });
      alert("Selected news deleted!");
      setNewsList(newsList.filter((news) => !selectedIds.includes(news._id)));
      setSelectedIds([]);
    } catch (error) {
      console.error("Failed to delete news:", error);
      alert("Failed to delete news.");
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Delete News</h2>
      <button
        onClick={handleBulkDelete}
        disabled={selectedIds.length === 0}
        className="mb-4 px-4 py-2 bg-red-600 text-white rounded"
      >
        Delete Selected ({selectedIds.length})
      </button>
      <ul className="space-y-2">
        {newsList.map((news) => (
          <li
            key={news._id}
            className="flex items-center justify-between border p-2 rounded"
          >
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={selectedIds.includes(news._id)}
                onChange={() => handleSelect(news._id)}
              />
              <span>{news.title}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DeleteNewsPage;